import { Skeleton, Stack } from "@skailer-com/uikit";

export function BlogPostSkeleton() {
  return (
    <Stack className={"bg-light rounded-sm shadow p-6"} gap={"md"}>
      <Stack gap={"smd"} direction={"horizontal"} items={"center"}>
        <Skeleton className={"w-12 h-12 rounded-sm"} />
        <Stack gap={"sm"}>
          <Skeleton className={"w-20 h-4"} />
          <Skeleton className={"w-40 h-4"} />
        </Stack>
      </Stack>
      <Stack gap={"sm"}>
        <Skeleton className={"w-48 h-7 rounded-sm"} />
        <Skeleton className={"w-40 h-5 rounded-sm"} />
        <div className={"block bg-dark/5 w-full h-88"}></div>
        <Skeleton className={"w-7 h-5 rounded-sm"} />
      </Stack>
    </Stack>
  );
}
